import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { constObj } from '../../common/Constants/constants';
import * as Papa from 'papaparse';
import { XbrlRec } from '../../common/models/xbrl-rec';
import { HttpcallService } from '../../common/services/httpcall.service';

@Component({
  selector: 'app-xbrldata',
  templateUrl: './xbrldata.component.html',
  styleUrls: ['./xbrldata.component.css']

})
export class XbrldataComponent implements OnInit {
  public displayedColumns = ['areaTitle', 'topic', 'subTopic', 'section', 'paragraph', 'subParagraph', 'elementName', 'title', 'elementID', 'refRole', 'status', 'lastUpdated'];



  public dataSource = new MatTableDataSource<XbrlRec>();
  xbrldataHeader: any;
  xbrldetails: any;
  xbrlbutton: any;
  xbrlonbutton: any;
  LastUpdated: any;
  Status: any;
  RefRole: any;
  ElementId: any;
  Title: any;
  ElementName: any;
  SubParagraph: any;
  Paragraph: any;
  Section: any;
  SubTopic: any;
  Topic: any;
  AreaTitle: any;
  outcome: boolean = true;
  len: number = 100;
  pagesize: any = 10;
  pagelistarray: number[] = [];
  xbrldata_100: any[] = [];

  private paginator: MatPaginator;
  private sort: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public xbrldata: any[] = [];
  public ondemandxbrldata: any[] = [];

  constructor(public dialog: MatDialog, private httpCallService: HttpcallService,
    public commonDataService: CommonDataService, private graphQlService: GraphqlService) { }

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.graphQlService.getXbrlLabels().subscribe(labels => { this.mapAccessManagementLabel(labels); })
    this.getXbrlData();
    this.getXbrlOnDemandData();

  }

  downloadData() {

    const rearrangedXbrlData = this.xbrldata.map(obj => ({
      areaTitle: obj.areaTitle,
      topic: obj.topic,
      subTopic: obj.subTopic,
      section: obj.section,
      paragraph: obj.paragraph != null && obj.paragraph.trim() != "" ? `${obj.paragraph?.split('-')[1]}` : obj.paragraph,
      subParagraph: obj.subParagraph,
      elementName: obj.elementName,
      title: obj.title,
      elementID: obj.elementID,
      refRole: obj.refRole,
      status: obj.status,
      lastUpdated: obj.lastUpdated
    }));
    rearrangedXbrlData.sort(this.customSortdownload);
    const csv = Papa.unparse(rearrangedXbrlData);
    const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const csvURL = window.URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.href = csvURL;

    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');

    const fileName = `xbrl_elements_${year}${month}${day}.csv`;

    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();


  }

  downloadondemandData() {
    const rearrangedXbrlData = this.ondemandxbrldata.map(obj => ({
      Paragraph_Subparagraph_Info: `${obj}`,

    }));

    rearrangedXbrlData.sort((a, b) => {
      const [aTopic, aSubTopic, aSection, aPara, aSubPara] = a.Paragraph_Subparagraph_Info.split('-');
      const [bTopic, bSubTopic, bSection, bPara, bSubPara] = b.Paragraph_Subparagraph_Info.split('-');

      return (
        aTopic.localeCompare(bTopic) ||
        compareFields(aSubTopic, bSubTopic) ||
        compareFields(aSection, bSection) ||
        compareFields(aPara, bPara) ||
        compareFields(aSubPara, bSubPara)
      );
    });

    function compareFields(a, b) {
      // Handle cases where a or b is undefined or empty
      if (!a && !b) {
        return 0;
      }
      if (!a) {
        return -1;
      }
      if (!b) {
        return 1;
      }
      return a.localeCompare(b);
    }

    const csv = Papa.unparse(rearrangedXbrlData, {
      columns: ["Paragraph_Subparagraph_Info"],
    });
    const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const csvURL = window.URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.href = csvURL;

    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');

    const fileName = `Paragraph_Subparagraph_Info_${year}${month}${day}.csv`;

    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

  }

  mapAccessManagementLabel(data) {
    if (data != "") {
      var labels = data.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.xbrldataHeader = labels.filter(x => x.key == "xbrlheader").map(y => y.value);
      this.xbrldetails = labels.filter(x => x.key == "xblrdesc").map(y => y.value);
      this.xbrlbutton = labels.filter(x => x.key == "xblrbutton").map(y => y.value);
      this.xbrlonbutton = labels.filter(x => x.key == "xblronbutton").map(y => y.value);
      this.LastUpdated = labels.filter(x => x.key == "lastupdated").map(y => y.value);
      this.Status = labels.filter(x => x.key == "status").map(y => y.value);
      this.RefRole = labels.filter(x => x.key == "refrole").map(y => y.value);
      this.ElementId = labels.filter(x => x.key == "eleid").map(y => y.value);
      this.Title = labels.filter(x => x.key == "title").map(y => y.value);
      this.ElementName = labels.filter(x => x.key == "elename").map(y => y.value);
      this.SubParagraph = labels.filter(x => x.key == "subpara").map(y => y.value);
      this.Paragraph = labels.filter(x => x.key == "para").map(y => y.value);
      this.Section = labels.filter(x => x.key == "sec").map(y => y.value);
      this.SubTopic = labels.filter(x => x.key == "subtopic").map(y => y.value);
      this.Topic = labels.filter(x => x.key == "topic").map(y => y.value);
      this.AreaTitle = labels.filter(x => x.key == "areatitle").map(y => y.value);

    }
  }

  getdata(xbrlData) {
    //var a = users.sort(this.customSort);
    this.xbrldata = xbrlData;
    this.xbrldata_100 = this.xbrldata.slice(0, 100);
    /*var a = this.xbrldata.sort(this.customSortdownload);*/
    this.displaydata(this.xbrldata_100);

  }
  getondata(subpara) {
    this.ondemandxbrldata = subpara;
  }

  getXbrlData() {

    this.httpCallService.getAllXbrlData().subscribe((xbrlData) => { this.getdata(xbrlData); this.outcome = true; this.commonDataService.showLoader.next(false); }, err => {
      let obj = {
        type: 'error',
        displayTime: 10000,
        position: 'bottom',
        message: constObj.xbrlDataLoadFailure
      }
      this.commonDataService.notificationObject.next(obj);
      this.outcome = true;
      console.log(err); this.commonDataService.showLoader.next(false);
    });

  }

  getXbrlOnDemandData() {
    this.httpCallService.getXbrlOnDemandData().subscribe((subpara) => { this.getondata(subpara); this.outcome = true; this.commonDataService.showLoader.next(false); }, err => {
      let obj = {
        type: 'error',
        displayTime: 10000,
        position: 'bottom',
        message: constObj.xbrlDataLoadFailure
      }
      this.commonDataService.notificationObject.next(obj);
      this.outcome = true;
      console.log(err); this.commonDataService.showLoader.next(false);
    });

  }

  displaydata(tableData: any) {
    if (tableData != null)
      tableData.sort(this.customSort);
    this.dataSource.data = tableData as unknown as XbrlRec[];
  }

  customSort(a: any, b: any): number {


    const column1Comparison = a.areaTitle.localeCompare(b.areaTitle);
    if (column1Comparison !== 0) {
      return column1Comparison;
    }

    // Sort based on column 2
    const column2Comparison = a.topic - b.topic;
    if (column2Comparison !== 0) {
      return column2Comparison;
    }

    // Sort based on column 3
    const column3Comparison = a.subTopic - b.subTopic;
    if (column3Comparison !== 0) {
      return column3Comparison;
    }

    const column4Comparison = a.section - b.section;
    if (column4Comparison !== 0) {
      return column4Comparison;
    }

    const column5Comparison = a.paragraph - b.paragraph;
    if (column5Comparison !== 0) {
      return column5Comparison;
    }

    const column6Comparison = a.subParagraph - b.subParagraph;
    if (column6Comparison !== 0) {
      return column6Comparison;
    }

    const column7Comparison = a.elementName - b.elementName;
    if (column7Comparison !== 0) {
      return column7Comparison;
    }

    const column8Comparison = a.title - b.title;
    if (column8Comparison !== 0) {
      return column8Comparison;
    }

    const column9Comparison = a.elementID - b.elementID;
    if (column9Comparison !== 0) {
      return column9Comparison;
    }

    const column10Comparison = a.refRole - b.refRole;
    if (column10Comparison !== 0) {
      return column10Comparison;
    }

    const column11Comparison = a.status - b.status;
    if (column11Comparison !== 0) {
      return column11Comparison;
    }

    const column12Comparison = a.lastUpdated - b.lastUpdated;
    if (column12Comparison !== 0) {
      return column12Comparison;
    }

    return 0; // Return 0 for equal elements
  }

  /*customSort(a: any, b: any): number {
    // Helper function to compare alphanumeric strings
    function compareAlphaNumeric(a: string, b: string): number {
      const numericPartRegex = /(\d+)/;

      // Extract numeric parts from the strings
      const aNumericPart = a.match(numericPartRegex);
      const bNumericPart = b.match(numericPartRegex);

      // If both have numeric parts, compare them as numbers
      if (aNumericPart && bNumericPart) {
        return parseInt(aNumericPart[0], 10) - parseInt(bNumericPart[0], 10);
      }

      // If one of them has a numeric part and the other is a letter, give priority to the letter
      if (aNumericPart) {
        return -1; // 'a' comes before '1'
      } else if (bNumericPart) {
        return 1; // '1' comes after 'a'
      }

      // If both are letters or don't have numeric parts, compare them as strings
      return a.localeCompare(b);
    }

    // Helper function to compare dates
    function compareDates(a: string, b: string): number {
      // Convert the date strings to Date objects and then compare their timestamps
      return new Date(a).getTime() - new Date(b).getTime();
    }

    {
      // Helper function to separate numeric and letter parts from alphanumeric values
      function separateAlphaNumeric(value: string): [number, string] {
        const match = value.match(/^(\d+)([A-Za-z]*)$/);
        const numericPart = match ? parseInt(match[1], 10) : NaN;
        const letterPart = match ? match[2] : '';
        return [numericPart, letterPart];
      }

      // Helper function to compare alphanumeric values in the paragraph column
      function compareAlphaNumericpara(a: string, b: string): number {
        const [numericA, letterA] = separateAlphaNumeric(a);
        const [numericB, letterB] = separateAlphaNumeric(b);

        if (numericA !== numericB) {
          return numericA - numericB; // Sort numbers in ascending order
        }

        // If numeric parts are equal, sort alphanumeric values alphabetically
        return letterA.localeCompare(letterB);
      }

    // Sort based on column 1 (areaTitle)
    const column1Comparison = a.areaTitle.localeCompare(b.areaTitle);
    if (column1Comparison !== 0) {
      return column1Comparison;
    }

    // Sort based on column 2 (topic)
    const column2Comparison = a.topic - b.topic;
    if (column2Comparison !== 0) {
      return column2Comparison;
    }

    // Sort based on column 3 (subTopic)
    const column3Comparison = a.subTopic - b.subTopic;
    if (column3Comparison !== 0) {
      return column3Comparison;
    }

    // Sort based on column 4 (section)
    const column4Comparison = a.section - b.section;
    if (column4Comparison !== 0) {
      return column4Comparison;
    }

    // Sort based on column 5 (paragraph)
      const column5Comparison = compareAlphaNumericpara(a.paragraph, b.paragraph);
    if (column5Comparison !== 0) {
      return column5Comparison;
    }

    // Sort based on column 6 (subParagraph)
      const column6Comparison = compareAlphaNumeric(a.subParagraph, b.subParagraph);
    if (column6Comparison !== 0) {
      return column6Comparison;
    }

    // Sort based on column 7 (elementName)
    const column7Comparison = a.elementName.localeCompare(b.elementName);
    if (column7Comparison !== 0) {
      return column7Comparison;
    }

    // Sort based on column 8 (title)
    const column8Comparison = a.title.localeCompare(b.title);
    if (column8Comparison !== 0) {
      return column8Comparison;
    }

    // Sort based on column 9 (elementID)
    const column9Comparison = a.elementID - b.elementID;
    if (column9Comparison !== 0) {
      return column9Comparison;
    }

    // Sort based on column 10 (refRole)
    const column10Comparison = a.refRole.localeCompare(b.refRole);
    if (column10Comparison !== 0) {
      return column10Comparison;
    }

    // Sort based on column 11 (status)
    const column11Comparison = a.status.localeCompare(b.status);
    if (column11Comparison !== 0) {
      return column11Comparison;
    }

    // Sort based on column 12 (lastUpdated)
    const column12Comparison = compareDates(a.lastUpdated, b.lastUpdated);
    if (column12Comparison !== 0) {
      return column12Comparison;
    }

    return 0; // Return 0 for equal elements
  }
*/

  /*customSortdownload(a: any, b: any): number {
    // Sort based on column 1 (areaTitle)
    const column1Comparison = a.areaTitle.localeCompare(b.areaTitle);
    if (column1Comparison !== 0) {
      return column1Comparison;
    }

    // Sort based on column 2 (topic)
    const column2Comparison = a.topic - b.topic;
    if (column2Comparison !== 0) {
      return column2Comparison;
    }

    // Sort based on column 3 (subTopic)
    const column3Comparison = a.subTopic - b.subTopic;
    if (column3Comparison !== 0) {
      return column3Comparison;
    }

    // Sort based on column 4 (section)
    const column4Comparison = a.section - b.section;
    if (column4Comparison !== 0) {
      return column4Comparison;
    }

    // Sort based on column 5 (paragraph)
    const column5Comparison = this.compareParagraph(a.paragraph, b.paragraph);
    if (column5Comparison !== 0) {
      return column5Comparison;
    }

    // Sort based on column 6 (subParagraph)
    const column6Comparison = this.compareSubParagraph(a.subParagraph, b.subParagraph);
    if (column6Comparison !== 0) {
      return column6Comparison;
    }

    // Sort based on column 7 (elementName)
    const column7Comparison = a.elementName.localeCompare(b.elementName);
    if (column7Comparison !== 0) {
      return column7Comparison;
    }

    // Sort based on column 8 (title)
    const column8Comparison = a.title.localeCompare(b.title);
    if (column8Comparison !== 0) {
      return column8Comparison;
    }

    // Sort based on column 9 (elementID)
    const column9Comparison = a.elementID - b.elementID;
    if (column9Comparison !== 0) {
      return column9Comparison;
    }

    // Sort based on column 10 (refRole)
    const column10Comparison = a.refRole.localeCompare(b.refRole);
    if (column10Comparison !== 0) {
      return column10Comparison;
    }

    // Sort based on column 11 (status)
    const column11Comparison = a.status.localeCompare(b.status);
    if (column11Comparison !== 0) {
      return column11Comparison;
    }

    // Sort based on column 12 (lastUpdated)
    const column12Comparison = new Date(a.lastUpdated).getTime() - new Date(b.lastUpdated).getTime();
    if (column12Comparison !== 0) {
      return column12Comparison;
    }

    return 0; // Return 0 for equal elements
  }

  // Helper function to compare paragraph column
  compareParagraph(a: string, b: string): number {
    const regex = /\d+|[a-zA-Z]+/g;
    const aMatches = a.match(regex);
    const bMatches = b.match(regex);

    for (let i = 0; i < Math.min(aMatches.length, bMatches.length); i++) {
      const aMatch = aMatches[i];
      const bMatch = bMatches[i];

      if (!isNaN(Number(aMatch)) && !isNaN(Number(bMatch))) {
        const numComparison = Number(aMatch) - Number(bMatch);
        if (numComparison !== 0) {
          return numComparison;
        }
      } else {
        const strComparison = aMatch.localeCompare(bMatch);
        if (strComparison !== 0) {
          return strComparison;
        }
      }
    }

    return aMatches.length - bMatches.length;
  }

  // Helper function to compare subParagraph column
  compareSubParagraph(a: string, b: string): number {
    const regex = /(\d+|[a-zA-Z]+)/g;
    const aMatches = a.match(regex);
    const bMatches = b.match(regex);

    for (let i = 0; i < Math.min(aMatches.length, bMatches.length); i++) {
      const aMatch = aMatches[i];
      const bMatch = bMatches[i];

      if (!isNaN(Number(aMatch)) && !isNaN(Number(bMatch))) {
        const numComparison = Number(aMatch) - Number(bMatch);
        if (numComparison !== 0) {
          return numComparison;
        }
      } else {
        const strComparison = aMatch.localeCompare(bMatch);
        if (strComparison !== 0) {
          return strComparison;
        }
      }
    }

    return aMatches.length - bMatches.length;
  }*/

  customSortdownload(a: any, b: any): number {

    /*function compareParagraph(a: string, b: string): number {

      function extractNumericPart(str: string): number {
        const numericPart = str.match(/\d+/);
        return numericPart ? parseInt(numericPart[0], 10) : NaN;
      }

      function isAlphanumeric(str: string): boolean {
        return /[a-zA-Z]/.test(str);
      }

      const aNumPart = extractNumericPart(a);
      const bNumPart = extractNumericPart(b);

      const aIsPureNumber = !isNaN(aNumPart);
      const bIsPureNumber = !isNaN(bNumPart);

      if (aIsPureNumber && !bIsPureNumber) {
        return -1; // Pure numbers should appear before alphanumeric
      } else if (!aIsPureNumber && bIsPureNumber) {
        return 1; // Alphanumeric should appear after pure numbers
      }

      if (aIsPureNumber && bIsPureNumber) {
        if (aNumPart !== bNumPart) {
          return aNumPart - bNumPart;
        } else {
          // Sort based on alphanumeric part if numbers are equal
          const aAlphaPart = a.replace(aNumPart.toString(), '');
          const bAlphaPart = b.replace(bNumPart.toString(), '');
          if (isAlphanumeric(aAlphaPart) && isAlphanumeric(bAlphaPart)) {
            return aAlphaPart.localeCompare(bAlphaPart);
          } else if (!isAlphanumeric(aAlphaPart) && isAlphanumeric(bAlphaPart)) {
            return -1; // Numeric part is same, but b has a letter after the number
          } else if (isAlphanumeric(aAlphaPart) && !isAlphanumeric(bAlphaPart)) {
            return 1; // Numeric part is same, but a has a letter after the number
          }
        }
      }

      return a.localeCompare(b); 
      
    }
  
    function compareSection(a: string, b: string): number {
      function extractNumericPart(str: string): number {
        const numericPart = str.match(/\d+/);
        return numericPart ? parseInt(numericPart[0], 10) : NaN;
      }

      function isAlphanumeric(str: string): boolean {
        return /[a-zA-Z]/.test(str);
      }

      const aNumPart = extractNumericPart(a);
      const bNumPart = extractNumericPart(b);

      const aIsPureNumber = !isNaN(aNumPart);
      const bIsPureNumber = !isNaN(bNumPart);

      if (aIsPureNumber && !bIsPureNumber) {
        return -1; // Pure numbers should appear before alphanumeric
      } else if (!aIsPureNumber && bIsPureNumber) {
        return 1; // Alphanumeric should appear after pure numbers
      }

      if (aIsPureNumber && bIsPureNumber) {
        return aNumPart - bNumPart;
      }

      return a.localeCompare(b); // Fallback: sort as strings
    }*/

    function compareSection(aa, bb): number {
      function extractNumericPart(str: string): number {
        const numericPart = str.match(/\d+/);
        return numericPart ? parseInt(numericPart[0], 10) : NaN;
      }

      const aHasData = aa !== "";
      const bHasData = bb !== "";

      if (!aHasData && !bHasData) {
        return 0; // Both have no data, consider them equal
      }

      if (!aHasData && bHasData) {
        return 1; // a has no data, prioritize b
      } else if (aHasData && !bHasData) {
        return -1; // b has no data, prioritize a
      }

      // Both a and b have data, proceed with the numeric and alphanumeric sorting logic
      const aNumPart = extractNumericPart(aa);
      const bNumPart = extractNumericPart(bb);

      const aIsPureNumber = !isNaN(aNumPart);
      const bIsPureNumber = !isNaN(bNumPart);

      if (aIsPureNumber && !bIsPureNumber) {
        return -1; // Pure numbers should appear before alphanumeric
      } else if (!aIsPureNumber && bIsPureNumber) {
        return 1; // Alphanumeric should appear after pure numbers
      }

      if (aIsPureNumber && bIsPureNumber) {
        const numComparison = aNumPart - bNumPart;
        if (numComparison !== 0) {
          return numComparison;
        }
      }

      return aa.localeCompare(bb); // Fallback: sort as strings
    }


    function compareParagraph(c, d): number {
      function extractNumericPart(str: string): number {
        const numericPart = str.match(/\d+/);
        return numericPart ? parseInt(numericPart[0], 10) : NaN;
      }

      const aHasData = c !== "";
      const bHasData = d !== "";

      if (!aHasData && !bHasData) {
        return 0; // Both have no data, consider them equal
      }

      if (!aHasData && bHasData) {
        return 1; // a has no data, prioritize b
      } else if (aHasData && !bHasData) {
        return -1; // b has no data, prioritize a
      }

      // Both a and b have data, proceed with the numeric and alphanumeric sorting logic
      const aNumPart = extractNumericPart(c);
      const bNumPart = extractNumericPart(d);

      const aIsPureNumber = !isNaN(aNumPart);
      const bIsPureNumber = !isNaN(bNumPart);

      if (aIsPureNumber && !bIsPureNumber) {
        return -1; // Pure numbers should appear before alphanumeric
      } else if (!aIsPureNumber && bIsPureNumber) {
        return 1; // Alphanumeric should appear after pure numbers
      }

      if (aIsPureNumber && bIsPureNumber) {
        if (aNumPart !== bNumPart) {
          return aNumPart - bNumPart;
        } else {
          // Sort based on alphanumeric part if numbers are equal
          const aAlphaPart = c.replace(aNumPart.toString(), '');
          const bAlphaPart = d.replace(bNumPart.toString(), '');
          return aAlphaPart.localeCompare(bAlphaPart);
        }
      }

      return c.localeCompare(d); // Fallback: sort as strings
    }

    function compareSubtopic(e, f): number {

      const aHasData = e !== "";
      const bHasData = f !== "";

      if (!aHasData && !bHasData) {
        return 0; // Both have no data, consider them equal
      }

      if (!aHasData && bHasData) {
        return 1; // a has no data, prioritize b
      } else if (aHasData && !bHasData) {
        return -1; // b has no data, prioritize a
      }

      return (e - f);

    }




    const column1Comparison = a.areaTitle.localeCompare(b.areaTitle);
    if (column1Comparison !== 0) {
      return column1Comparison;
    }

    // Sort based on column 2
    const column2Comparison = a.topic - b.topic;
    if (column2Comparison !== 0) {
      return column2Comparison;
    }

    // Sort based on column 3
    const column3Comparison = compareSubtopic(a.subTopic, b.subTopic);
    if (column3Comparison !== 0) {
      return column3Comparison;
    }

    const column4Comparison = compareSection(a.section, b.section);
    if (column4Comparison !== 0) {
      return column4Comparison;
    }

    const column5Comparison = compareParagraph(a.paragraph, b.paragraph);
    if (column5Comparison !== 0) {
      return column5Comparison;
    }

    const column6Comparison = compareSubtopic(a.subParagraph, b.subParagraph);
    if (column6Comparison !== 0) {
      return column6Comparison;
    }

    const column7Comparison = a.elementName - b.elementName;
    if (column7Comparison !== 0) {
      return column7Comparison;
    }

    const column8Comparison = a.title - b.title;
    if (column8Comparison !== 0) {
      return column8Comparison;
    }

    const column9Comparison = a.elementID - b.elementID;
    if (column9Comparison !== 0) {
      return column9Comparison;
    }

    const column10Comparison = a.refRole - b.refRole;
    if (column10Comparison !== 0) {
      return column10Comparison;
    }

    const column11Comparison = a.status - b.status;
    if (column11Comparison !== 0) {
      return column11Comparison;
    }

    const column12Comparison = - (a.getTime() - b.getTime());
    if (column12Comparison !== 0) {
      return column12Comparison;
    }

    return 0; // Return 0 for equal elements
  }



}



